export function serializeEntry(item) {
    return ({
        userId: item.userId,
        addedAt: item.addedAt,
        publicKey: item.publicKey,
        privateKey: item.privateKey,
    });
}
export function deserializeEntry(item) {
    return ({
        userId: item.userId,
        addedAt: new Date(item.addedAt),
        publicKey: item.publicKey,
        privateKey: item.privateKey,
    });
}
